"use strict";

exports.__esModule = true;
var _AppRoute = require("./AppRoute");
Object.keys(_AppRoute).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _AppRoute[key]) return;
  exports[key] = _AppRoute[key];
});
var _LandingPageWithRoutes = require("./LandingPageWithRoutes");
Object.keys(_LandingPageWithRoutes).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _LandingPageWithRoutes[key]) return;
  exports[key] = _LandingPageWithRoutes[key];
});